import React from 'react'
import { ButtonIcon } from '../../../components'
import { brandColors } from 'shared/basicPalette'

type ResourceItemActionButtonProps = {
  icon: React.ReactNode
  hint: string
  'aria-label': string
} & React.ComponentProps<typeof ButtonIcon>

export const ResourceItemActionButton: React.FC<ResourceItemActionButtonProps> =
  (props) => {
    return (
      <ButtonIcon
        {...props}
        borderRadius="100%"
        color={brandColors.grey['500']}
      />
    )
  }
